import { Link, createFileRoute } from "@tanstack/react-router";
import { toggleTwoStepVerification } from "@/queries/clients";
import { Card, CardContent, CardTitle, CardHeader } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { useStore } from "@tanstack/react-store";
import userStore from "@/stores/user-store";
import { convertDateTime } from "@/lib/utils";
import ChangePassword from "@/components/change-password";
import { getProfile } from "@/queries/profile";
import Alerting from "@/components/settings/alerting";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

export const Route = createFileRoute("/client/settings/")({
  component: ClientSettings,
});

function ClientSettings() {
  const { user: currentUser, two_step } = useStore(userStore);
  const [twoStep, setTwoStep] = useState(two_step);
  const [profile, setProfile] = useState<any>({});

  const profileQuery = useQuery({
    queryFn: () => getProfile(),
    queryKey: ["get", "profile"],
  });

  useEffect(() => {
    if (profileQuery.data?.data) {
      setProfile(profileQuery.data.data.data);
    }
  }, [profileQuery.data]);

  const toggleMutation = useMutation({
    mutationFn: () => toggleTwoStepVerification(),
    mutationKey: ["toggleTwoStep"],
    onSuccess() {
      setTwoStep(!twoStep);
      if (currentUser != undefined) {
        userStore.setState((prev) => ({ ...prev, two_step: !twoStep }));
      }
    },
    onError() {
      toast.error("خطایی در فعال سازی ورود دو مرحله ای رخ داده است...");
    },
  });

  const handleChecked = () => {
    toggleMutation.mutate();
  };

  return (
    <>
      <div className="flex justify-between items-center mb-8">
        <h3 className="text-lg font-medium">تنظیمات کاربری</h3>
        <Link to="/client/settings/security">
          <Button>
            <Shield className="ml-2" />
            تنظیمات امنیتی
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {currentUser?.type == "webservice" && (
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">اطلاعات IP های مجاز </CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-2 items-start" dir="ltr">
              {profile?.ips ? (
                profile?.ips?.split("-").map((ip: any, index: any) => (
                  <p key={index}>
                    {index + 1}. {ip}
                  </p>
                ))
              ) : (
                <>هیج ip معتبری برای شما ثبت نشده است</>
              )}
            </CardContent>
          </Card>
        )}

        <Card className="flex flex-col sm:flex-row items-start sm:items-center justify-between rounded-lg border p-4 gap-4">
          <div className="space-y-0.5">
            <Label className="text-base font-medium">ورود دو مرحله ای</Label>
            <div className="text-sm text-muted-foreground">
              برای امنیت بیشتر حساب کاربری خود می توانید ورود دو مرحله ای را
              تنظیم کنید...
            </div>
          </div>
          <div>
            <Switch
              loading={toggleMutation.isPending}
              defaultChecked={two_step}
              checked={twoStep}
              onCheckedChange={handleChecked}
            />
          </div>
        </Card>

        <ChangePassword />

        <div className="lg:col-span-2">
          <Alerting />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>اطلاعات آخرین ورود</CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col sm:flex-row gap-4 sm:items-center">
            <div className="flex flex-col gap-2 flex-1">
              <Label>آخرین ورود</Label>
              {convertDateTime(currentUser?.last_login.split("/")[1]) ||
                "اطلاعاتی موجود نیست"}
            </div>
            <div className="flex flex-col gap-2 flex-1">
              <Label>آدرس آی پی آخرین ورود</Label>
              {currentUser?.last_login.split("/")[0] || "اطلاعاتی موجود نیست"}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
